import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

/**
 * Created by Jerker Nord on 2020-04-01.
 */

export class FSIntroPage extends PIXI.Container {

    private _animation:PIXI.spine.Spine;
    private _text:PIXI.Text;
    private _textString:string;
    private _textStyle:PIXI.TextStyle;

    constructor(animation:PIXI.spine.Spine, textString:string, textStyle:PIXI.TextStyle) {
        super();
        this._animation = animation;
        this._animation.position.set(0, 40);
        this.addChild(this._animation);
        this._textString = textString;
        this._textStyle = textStyle;
        this._text = new PIXI.Text(SlotGame.api.translations.translate(textString), textStyle);
        this._text.position.set(-240, 20);
        this.addChild(this._text);
    }


    get animation():PIXI.spine.Spine {
        return this._animation;
    }
}